// extracted by mini-css-extract-plugin
module.exports = {"center":"center___3psma","container":"container___3kKTX"};